module.exports = __webpack_public_path__ + "static/media/PaymentSettings.e42e87cd.svg";